module.exports = __webpack_public_path__ + "static/media/ceo_title_cn.a840ad5f.png";